import { render, staticRenderFns } from "./emergency-services.vue?vue&type=template&id=4187b521&"
import script from "./emergency-services.vue?vue&type=script&lang=js&"
export * from "./emergency-services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports